
































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import SearchForm from "../components/SearchForm/index.vue";
import BaseTable from "../components/BaseTable/index.vue";
import { apiSaleBanList } from "../config/service";
import { PageSizeMixin } from "../config/PageSizeMixin";
import { SALE_COLUMNS } from "../config/index";
import AddModal from "./components/AddModal/index.vue";
import { gameList } from "@/req/gameManage";

@Component({
  components: { headerTitle, SearchForm, BaseTable, AddModal },
  mixins: [PageSizeMixin],
})
export default class Home extends Vue {
  public columns = SALE_COLUMNS;
  public formInline = {
    game_id: "",
    role_id: "",
  };
  public gameList = [];
  public API = apiSaleBanList;
  public addClick(row?, key?) {
    const $AddModal: any = this.$refs.AddModal;
    $AddModal.show(row, key);
  }
  public mounted() {
    this.getGameList();
  }
  public async getGameList() {
    const res = await gameList({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code == 0) {
      /* res.data.forEach((item) => {
        item.box_game_id = item.box_game_id.toString();
      }); */
      this.gameList = res.data;
    }
  }
}
